import React, { useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import "../Styles/HotelBooking.css";

const HotelBooking = () => {
  const { state } = useLocation();
  const navigate = useNavigate();

  const [error, setError] = useState("");
  const [promo, setPromo] = useState("");
  const [discount, setDiscount] = useState(0);

  const [form, setForm] = useState({
    name: "",
    email: "",
    checkIn: "",
    checkOut: "",
    adults: 1,
    children: 0,
    roomType: "standard",
    breakfast: false,
    pickup: false,
    payment: "card"
  });

  if (!state) return <h2>No Hotel Selected</h2>;

  const basePrice = parseInt(state.price.replace(/[^0-9]/g, ""));

  const roomPrices = { standard: 0, deluxe: 4000, suite: 8000 };

  const extras =
    (form.breakfast ? 2000 : 0) +
    (form.pickup ? 5000 : 0) +
    roomPrices[form.roomType];

  // DATE VALIDATION + NIGHTS
  let nights = 1;
  if (form.checkIn && form.checkOut) {
    const inDate = new Date(form.checkIn);
    const outDate = new Date(form.checkOut);
    if (outDate <= inDate) {
      setTimeout(() => setError("Check-out must be after Check-in"), 0);
    } else {
      nights = (outDate - inDate) / (1000 * 60 * 60 * 24);
      if (error) setError("");
    }
  }

  const subTotal = nights * (basePrice + extras);
  const tax = Math.round(subTotal * 0.08);
  const total = subTotal + tax - discount;

  const handleChange = (e) => {
    const { name, value, type, checked } = e.target;
    setForm({ ...form, [name]: type === "checkbox" ? checked : value });
  };

  const applyPromo = () => {
    if (promo === "DEZY10") {
      setDiscount(Math.round(subTotal * 0.1));
    } else {
      setDiscount(0);
      alert("Invalid Promo Code");
    }
  };

  const handleBooking = (e) => {
    e.preventDefault();
    if (error) return;
    alert(`Booking Confirmed 🎉\nTotal: PKR ${total}`);
    navigate("/hotel");
  };

  return (
    <div className="hotel-booking-page">
      <button className="back-btn" onClick={() => navigate(-1)}>⬅ Back</button>

      {/* 🔵 PROGRESS */}
      <div className="progress">
        <span className="active">Search</span>
        <span className="active">Details</span>
        <span>Payment</span>
        <span>Confirm</span>
      </div>

      <div className="booking-layout">
        {/* LEFT */}
        <div className="booking-card">
          <img src={state.img} alt={state.name} />

          <div className="booking-info">
            <h1>{state.name}</h1>
            <span className="badge">Only 2 rooms left</span>

            <form className="booking-form" onSubmit={handleBooking}>
              <input name="name" placeholder="Full Name" required onChange={handleChange} />
              <input name="email" type="email" placeholder="Email" required onChange={handleChange} />

              <div className="row">
                <input type="date" name="checkIn" required onChange={handleChange} />
                <input type="date" name="checkOut" required onChange={handleChange} />
              </div>

              {error && <p className="error">{error}</p>}

              <div className="row">
                <select name="adults" onChange={handleChange}>
                  <option>1 Adult</option>
                  <option>2 Adults</option>
                  <option>3 Adults</option>
                </select>

                <select name="children" onChange={handleChange}>
                  <option>0 Children</option>
                  <option>1 Child</option>
                  <option>2 Children</option>
                </select>
              </div>

              <select name="roomType" onChange={handleChange}>
                <option value="standard">Standard Room</option>
                <option value="deluxe">Deluxe (+4000)</option>
                <option value="suite">Suite (+8000)</option>
              </select>

              <div className="extras">
                <label><input type="checkbox" name="breakfast" onChange={handleChange}/> Breakfast (+2000)</label>
                <label><input type="checkbox" name="pickup" onChange={handleChange}/> Airport Pickup (+5000)</label>
              </div>

              {/* PROMO */}
              <div className="promo">
                <input placeholder="Promo Code" onChange={(e) => setPromo(e.target.value)} />
                <button type="button" onClick={applyPromo}>Apply</button>
              </div>

              {/* PAYMENT */}
              <h3>Payment</h3>
              <div className="payments">
                <label><input type="radio" name="payment" value="card" checked onChange={handleChange}/> Card</label>
                <label><input type="radio" name="payment" value="cash" onChange={handleChange}/> Pay at Hotel</label>
              </div>

              <button type="submit">Confirm Booking</button>
            </form>
          </div>
        </div>

        {/* RIGHT SUMMARY */}
        <div className="summary">
          <h3>Price Breakdown</h3>
          <p>Room × {nights} nights: PKR {subTotal}</p>
          <p>Tax (8%): PKR {tax}</p>
          {discount > 0 && <p className="discount">Promo Discount: -PKR {discount}</p>}
          <hr />
          <h2>Total: PKR {total}</h2>

          <div className="secure">
            🔒 Secure Payment <br />
            ✔ Free Cancellation <br />
            ⭐ 4.6 Guest Rating
          </div>
        </div>
      </div>
    </div>
  );
};

export default HotelBooking;
